import React from 'react'
import { mobile } from './tokens'
import { MobileSearchField } from './MobileSearchField'

interface MobileFilterBarProps {
  search?: string
  onSearchChange?: (value: string) => void
  searchPlaceholder?: string
  children?: React.ReactNode
  className?: string
}

/** Search + filter controls in a compact native surface. */
export function MobileFilterBar({
  search,
  onSearchChange,
  searchPlaceholder,
  children,
  className = '',
}: MobileFilterBarProps) {
  return (
    <div className={`${mobile.surface} p-3 ${className}`.trim()}>
      <div className="flex flex-col gap-2.5">
        {onSearchChange != null && search != null && (
          <MobileSearchField
            value={search}
            onChange={onSearchChange}
            placeholder={searchPlaceholder}
          />
        )}
        {children && <div className="flex flex-wrap gap-2">{children}</div>}
      </div>
    </div>
  )
}

interface MobileSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string
}

export function MobileSelect({ className = '', children, ...rest }: MobileSelectProps) {
  return (
    <select
      {...rest}
      className={`min-h-[44px] flex-1 min-w-[8.5rem] px-3 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white ${className}`.trim()}
    >
      {children}
    </select>
  )
}
